(function () {

  function getCurrentVariants(card, variants) {
    const selectedOptions = {};
    card.querySelectorAll('.card-product-options').forEach(select => {
      const optionName = select.getAttribute('data-option-name');
      if (optionName) {
        selectedOptions[optionName] = select.value;
      }
    });
    
    const variant = variants.find(v => {
      return Object.keys(selectedOptions).every(key => v.options.includes(selectedOptions[key]));
    });
    if (variant) {
      return variant;
    }
    return null;
  }

  function setupDynamicCheckout(card, variants) {
    if (!variants || !variants.length) {
      return;
    }

    // 如果未启用 Shopify Payments
    if (!window.Shopify || !window.Shopify.PaymentButton) {
      return;
    }

    const container = document.createElement('div');
    container.className = 'dynamic-checkout-container';

    // 创建动态结账表单 TODO: 需再调整
    const form = document.createElement('form');
    form.action = '/cart/add'; 
    form.method = 'post';
    form.enctype = 'multipart/form-data';

    // 添加规格ID
    const variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.className = 'dynamic-variant-id';
    variantInput.value = variants[0].id; // 默认选择第一个变体
    form.appendChild(variantInput);

    // 添加数量输入
    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1'; // 默认数量为1
    form.appendChild(quantityInput);

    // 创建 Shopify 动态结账按钮容器
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'shopify-payment-button';
    buttonContainer.setAttribute('data-shopify', 'payment-button');
    
    // 创建加速结账容器，需要配置正确的Web Components属性，目前存在问题
    const acceleratedCheckout = document.createElement('shopify-accelerated-checkout');
    acceleratedCheckout.setAttribute('data-storefront-currency', 'USD');
    acceleratedCheckout.setAttribute('data-shop-id', '86724182298');
    acceleratedCheckout.setAttribute('access-token', '6310c95b0f500b75eb7eba893efc923e');
    
    // 创建加速结账按钮
    const acceleratedButton = document.createElement('shopify-accelerated-checkout-cart');
    acceleratedButton.setAttribute('wallet-configs', JSON.stringify([
      {
        name: 'shop_pay',
        wallet_params: {
          shop_id: '86724182298',
          merchatName: 'Aqara LLC'
        }
      }
    ]));
    // 添加必要的产品信息属性
    acceleratedButton.setAttribute('data-product-id', variants[0].product_id);
    acceleratedButton.setAttribute('data-variant-id', variants[0].id);
    acceleratedButton.setAttribute('data-quantity', '1');
    
    acceleratedCheckout.appendChild(acceleratedButton);
    buttonContainer.appendChild(acceleratedCheckout);
    form.appendChild(buttonContainer);

    const addToCartButton = card.querySelector('.add-to-cart');
    if (addToCartButton) {
      addToCartButton.parentNode.replaceChild(container, addToCartButton);
      container.appendChild(form);
    }

    // 关键：需要等待 DOM 插入后再初始化
    const initTimeout = setTimeout(() => {
      clearTimeout(initTimeout);
      // 初始化 Shopify 动态结账
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
      
      // 需要手动触发Web Components
      if (window.customElements && window.customElements.get('shopify-accelerated-checkout')) {
        // 已注册，直接使用
      }
    }, 100);
  }
  
  function getCartShow() {
    fetch(`${window.theme.routes.cart_update_url}.js`, {
      method: 'POST',
    })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          detail: {
            cart: response,
          },
          bubbles: true,
        })
      );
      // 打开购物车抽屉
      const drawerElem = document.querySelector(
        'a.navlink[data-drawer-toggle=drawer-cart]'
      );
      drawerElem.click();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  function addToCartHandler(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const variantId = button.getAttribute('data-id');
    if (!variantId) {
      console.warn('No variant ID found for add to cart button');
      return;
    }
    const formData = [{id: variantId, quantity: 1 }];
    fetch(`${window.theme.routes.cart}/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: formData,
      }),
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        getCartShow();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  function createSelectElement(card, selectInfo, variants) {
    const { name, values } = selectInfo;
    if (!name || !values || !Array.isArray(values) || values.length === 0) {
      console.warn('Invalid selectInfo:', selectInfo);
      return null;
    }

    // 创建带label的下拉选择框
    const selectDiv = document.createElement('div');
    selectDiv.className = 'card-product-options-container';
    const label = document.createElement('label');
    label.textContent = name;
    label.className = 'card-product-options-label';
    label.setAttribute('for', `card-product-options-${name}`);
    const select = document.createElement('select');
    select.className = 'card-product-options';
    select.setAttribute('data-option-name', name);
    values.forEach(option => {
      const opt = document.createElement('option');
      opt.value = option;
      opt.textContent = option;
      select.appendChild(opt);
    });

    // 默认选择第一项
    if (values.length > 0) {
      select.value = values[0];
    }
    selectDiv.appendChild(label);
    selectDiv.appendChild(select);

    // 添加事件监听器
    select.addEventListener('change', function() {

      const curVariant = getCurrentVariants(card, variants);
      if (!curVariant) {
        return;
      }

      // 修改产品图片显示
      const imageElement = card.querySelector('.card-image img');
      if (imageElement) {
        const { featured_image, name } = curVariant;
        if (featured_image && featured_image.src) {
          imageElement.src = featured_image.src;
        }
        imageElement.alt = name || 'Product Image';
      }

      // 修改产品价格显示
      const priceElement = card.querySelector('.card-price');
      if (priceElement) {
        priceElement.textContent = `$${(curVariant.price / 100).toFixed(2)}`;
      }
      
      // 更新变体ID
      const addToCartButton = card.querySelector('.add-to-cart');
      if (addToCartButton) {
        addToCartButton.setAttribute('data-id', curVariant.id);
      }
      const variantInput = card.querySelector('.dynamic-variant-id');
      if (variantInput) {
        variantInput.value = curVariant.id;
      }
    });
    return selectDiv;
  }

  function addCard(link, productUrl, handle, model) {
    const card = document.createElement('div');
    const isNewWindow = link.getAttribute('target') === '_blank' ? ' target="_blank"' : '';

    card.className = 'article-product-card';
    if (model) {
      card.classList.add(`model-${model}`);
    }
    card.innerHTML = `
    <div class="card-image"></div>
    <div class="card-info">
      <h3 class="card-title">${link.textContent}</h3>
      <p class="card-price"></p>
      <div class="card-description"></div>
      <div class="card-selection"></div>
      <div class="card-button">
        <a href="${productUrl}" ${isNewWindow} class="card-link">Learn More</a>
        <button class="card-link add-to-cart">
          Add to Cart
        </button>
      </div>
    </div>
    `;
    link.parentNode.replaceChild(card, link);

    // AJAX 获取产品信息
    fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      console.log('Product data:', product);
      const { title, description, featured_image, price, variants, options } = product;
      // 填充卡片内容
      card.querySelector('.card-image').innerHTML = `<img src="${featured_image}" alt="${title}">`;
      card.querySelector('.card-title').textContent = title;
      card.querySelector('.card-price').textContent = `$${(price / 100).toFixed(2)}`;
      card.querySelector('.card-description').innerHTML = description ? description.replace(/<[^>]+>/g, '') : '暂无描述';
      // 添加规格选择区
      if (model == 2) {
        if (options.length > 0) {
          options.forEach(option => {
            const selectOption = createSelectElement(card, option, variants);
            if (selectOption) {
              card.querySelector('.card-selection').appendChild(selectOption);
            }
          });
        }
      }
      // 配置动态结账按钮，存在问题，暂使用加入购物车
      // setupDynamicCheckout(card, variants);
      const addToCartButton = card.querySelector('.add-to-cart');
      if (addToCartButton) {
        addToCartButton.setAttribute('data-id', variants[0].id);
        addToCartButton.addEventListener('click', addToCartHandler);
      }
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
      // card.querySelector('.card-description').textContent = '无法加载产品信息';
    });
  }

  function renderProductCards() {
    const blogContent = document.querySelector('.article-template__content, .rte, .blog-article-content');
    if (!blogContent) return;

    blogContent.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
      const productUrl = link.getAttribute('href');
      // 不是产品链接，不处理
      const match = productUrl.match(/\/products\/([^/?#]+)/);
      if (!match) return;

      // 查询参数不含type=card，不处理
      const searchString = productUrl.split('?')[1];
      const searchParams = {};
      new URLSearchParams(searchString).forEach((value, key) => {
        searchParams[key] = value;
      });
      const { type, model } = searchParams;
      if (!type || type !== 'card') return;

      const handle = match[1];
      const articleUrl = window.location.pathname.split('/').pop();
      const curProductUrl = `/products/${handle}?utm=blogs&from=${articleUrl}`;
      addCard(link, curProductUrl, handle, model);
    });
  }

  document.addEventListener('DOMContentLoaded', renderProductCards);
  
})();
    